import { getIconRegistry } from "../registry";
export class IconRegistry {
    constructor() {
        this.assetsPath = undefined;
        this.theme = undefined;
    }
    componentWillLoad() {
        if (typeof this.assetsPath === "string") {
            getIconRegistry().setAssetsPath(this.assetsPath);
        }
        // @ts-expect-error Check for typing
        if (["web", "responsive"].includes(this.theme)) {
            // @ts-expect-error Check for typing
            getIconRegistry().setTheme(this.theme);
        }
    }
    static get is() { return "ux-icon-registry"; }
    static get properties() {
        return {
            "assetsPath": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string | undefined",
                    "resolved": "string | undefined",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Configure public path where asset files are served from"
                },
                "attribute": "assets-path",
                "reflect": false
            },
            "theme": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "IconThemeType | undefined",
                    "resolved": "\"responsive\" | \"web\" | undefined",
                    "references": {
                        "IconThemeType": {
                            "location": "import",
                            "path": "../types",
                            "id": "src/components/icon/types.ts::IconThemeType"
                        }
                    }
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Configure the icon theme explicitly"
                },
                "attribute": "theme",
                "reflect": false
            }
        };
    }
}
//# sourceMappingURL=icon-registry.js.map
